// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EvaluationGroupActionModal-module__container {
  width: 448px;
  /* height: 357px; */
  height:400px;
  box-sizing: border-box;
  background: #ffffff;
  border: 0.8px solid #bcbcbc;
  border-radius: 10px;
  padding: 24px;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.EvaluationGroupActionModal-module__closeHeader {
  position: absolute;
  top: 20px;
  right: 20px;
}

.EvaluationGroupActionModal-module__closeBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
}

.EvaluationGroupActionModal-module__title {
  margin: 0 40px 8px 0;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  font-size: 18px;
  line-height: 150%;
  color: #263643;
}

.EvaluationGroupActionModal-module__subtitle {
  margin: 0 0 16px;
  font-family: Montserrat, sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  color: #556575;
}

.EvaluationGroupActionModal-module__selectWrapper {
  flex: 1;
  min-height: 0;
  width: 100%;
}

.EvaluationGroupActionModal-module__selectBox {
  width: 100%;
  display: flex;
  flex-direction: column;
  border: 1px solid #bcbcbc;
  border-radius: 8px;
  overflow: hidden;
  background: #ffffff;
}

.EvaluationGroupActionModal-module__selectBoxClosed {
  align-self: flex-start;
}

.EvaluationGroupActionModal-module__selectTrigger {
  flex-shrink: 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: #ffffff;
  border: none;
  cursor: pointer;
}

.EvaluationGroupActionModal-module__selectBoxOpen .EvaluationGroupActionModal-module__selectTrigger {
  border-bottom: 1px solid #e2e2e2;
}

.EvaluationGroupActionModal-module__placeholderText {
  font-family: Montserrat, sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  color: #bcbcbc;
}

.EvaluationGroupActionModal-module__selectedText {
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
  color: #263643;
}

.EvaluationGroupActionModal-module__arrDownIcon {
  width: 9px;
  height: 5px;
  transition: transform 0.2s ease;
}

.EvaluationGroupActionModal-module__arrDownIconOpen {
  transform: rotate(180deg);
}

.EvaluationGroupActionModal-module__phasesError,
.EvaluationGroupActionModal-module__phasesEmpty {
  margin: 0;
  padding: 12px 20px;
  font-family: Montserrat, sans-serif;
  font-size: 13px;
  line-height: 150%;
  color: #ff3b30;
}

.EvaluationGroupActionModal-module__phasesEmpty {
  color: #556575;
}

.EvaluationGroupActionModal-module__phasesError button {
  background: none;
  border: none;
  padding: 0;
  font-weight: 600;
  color: #324452;
  cursor: pointer;
  text-decoration: underline;
}

.EvaluationGroupActionModal-module__selectTrigger:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.EvaluationGroupActionModal-module__optionsList {
  list-style: none;
  margin: 0;
  padding: 0;
}

.EvaluationGroupActionModal-module__selectBoxClosed .EvaluationGroupActionModal-module__optionsList {
  display: none;
}

.EvaluationGroupActionModal-module__selectBoxOpen .EvaluationGroupActionModal-module__optionsList {
  display: block;
}

.EvaluationGroupActionModal-module__optionsList li + li {
  border-top: 1px solid #e2e2e2;
}

.EvaluationGroupActionModal-module__optionButton {
  width: 100%;
  min-height: 53px;
  padding: 16px 20px;
  background: #ffffff;
  border: none;
  text-align: left;
  cursor: pointer;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 150%;
  color: #263643;
}

.EvaluationGroupActionModal-module__optionButton:hover {
  background-color: #f8f8f8;
}

.EvaluationGroupActionModal-module__optionButton:disabled {
  cursor: wait;
  opacity: 0.7;
}

.EvaluationGroupActionModal-module__btnContainer {
  display: flex;
  gap: 16px;
  margin-top: auto;
  flex-shrink: 0;
}

.EvaluationGroupActionModal-module__cancelBtn,
.EvaluationGroupActionModal-module__proceedBtn {
  flex: 1;
  height: 45px;
  border-radius: 56px;
  font-family: Montserrat, sans-serif;
  font-weight: 600;
  font-size: 14px;
  line-height: 100%;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  cursor: pointer;
}

.EvaluationGroupActionModal-module__cancelBtn {
  background-color: #ffffff;
  border: 1px solid #263643;
  color: #263643;
}

.EvaluationGroupActionModal-module__proceedBtn {
  background-color: #bcbcbc;
  border: none;
  color: #ffffff;
  cursor: not-allowed;
}

.EvaluationGroupActionModal-module__proceedBtnEnabled {
  background-color: #324452;
  cursor: pointer;
}

.EvaluationGroupActionModal-module__proceedBtnEnabled:hover {
  background-color: #263643;
}
`, "",{"version":3,"sources":["webpack://./src/modals/evaluationgroupaction/EvaluationGroupActionModal.module.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;EAC3B,mBAAmB;EACnB,aAAa;EACb,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,SAAS;EACT,kBAAkB;EAClB,mCAAmC;EACnC,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,OAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,mCAAmC;EACnC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".container {\n  width: 448px;\n  /* height: 357px; */\n  height:400px;\n  box-sizing: border-box;\n  background: #ffffff;\n  border: 0.8px solid #bcbcbc;\n  border-radius: 10px;\n  padding: 24px;\n  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n}\n\n.closeHeader {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n}\n\n.closeBtn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n}\n\n.title {\n  margin: 0 40px 8px 0;\n  font-family: Montserrat, sans-serif;\n  font-weight: 600;\n  font-size: 18px;\n  line-height: 150%;\n  color: #263643;\n}\n\n.subtitle {\n  margin: 0 0 16px;\n  font-family: Montserrat, sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 150%;\n  color: #556575;\n}\n\n.selectWrapper {\n  flex: 1;\n  min-height: 0;\n  width: 100%;\n}\n\n.selectBox {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  border: 1px solid #bcbcbc;\n  border-radius: 8px;\n  overflow: hidden;\n  background: #ffffff;\n}\n\n.selectBoxClosed {\n  align-self: flex-start;\n}\n\n.selectTrigger {\n  flex-shrink: 0;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  background: #ffffff;\n  border: none;\n  cursor: pointer;\n}\n\n.selectBoxOpen .selectTrigger {\n  border-bottom: 1px solid #e2e2e2;\n}\n\n.placeholderText {\n  font-family: Montserrat, sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 150%;\n  color: #bcbcbc;\n}\n\n.selectedText {\n  font-family: Montserrat, sans-serif;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n  color: #263643;\n}\n\n.arrDownIcon {\n  width: 9px;\n  height: 5px;\n  transition: transform 0.2s ease;\n}\n\n.arrDownIconOpen {\n  transform: rotate(180deg);\n}\n\n.phasesError,\n.phasesEmpty {\n  margin: 0;\n  padding: 12px 20px;\n  font-family: Montserrat, sans-serif;\n  font-size: 13px;\n  line-height: 150%;\n  color: #ff3b30;\n}\n\n.phasesEmpty {\n  color: #556575;\n}\n\n.phasesError button {\n  background: none;\n  border: none;\n  padding: 0;\n  font-weight: 600;\n  color: #324452;\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n.selectTrigger:disabled {\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.optionsList {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.selectBoxClosed .optionsList {\n  display: none;\n}\n\n.selectBoxOpen .optionsList {\n  display: block;\n}\n\n.optionsList li + li {\n  border-top: 1px solid #e2e2e2;\n}\n\n.optionButton {\n  width: 100%;\n  min-height: 53px;\n  padding: 16px 20px;\n  background: #ffffff;\n  border: none;\n  text-align: left;\n  cursor: pointer;\n  font-family: Montserrat, sans-serif;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 150%;\n  color: #263643;\n}\n\n.optionButton:hover {\n  background-color: #f8f8f8;\n}\n\n.optionButton:disabled {\n  cursor: wait;\n  opacity: 0.7;\n}\n\n.btnContainer {\n  display: flex;\n  gap: 16px;\n  margin-top: auto;\n  flex-shrink: 0;\n}\n\n.cancelBtn,\n.proceedBtn {\n  flex: 1;\n  height: 45px;\n  border-radius: 56px;\n  font-family: Montserrat, sans-serif;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 100%;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n  cursor: pointer;\n}\n\n.cancelBtn {\n  background-color: #ffffff;\n  border: 1px solid #263643;\n  color: #263643;\n}\n\n.proceedBtn {\n  background-color: #bcbcbc;\n  border: none;\n  color: #ffffff;\n  cursor: not-allowed;\n}\n\n.proceedBtnEnabled {\n  background-color: #324452;\n  cursor: pointer;\n}\n\n.proceedBtnEnabled:hover {\n  background-color: #263643;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `EvaluationGroupActionModal-module__container`,
	"closeHeader": `EvaluationGroupActionModal-module__closeHeader`,
	"closeBtn": `EvaluationGroupActionModal-module__closeBtn`,
	"title": `EvaluationGroupActionModal-module__title`,
	"subtitle": `EvaluationGroupActionModal-module__subtitle`,
	"selectWrapper": `EvaluationGroupActionModal-module__selectWrapper`,
	"selectBox": `EvaluationGroupActionModal-module__selectBox`,
	"selectBoxClosed": `EvaluationGroupActionModal-module__selectBoxClosed`,
	"selectTrigger": `EvaluationGroupActionModal-module__selectTrigger`,
	"selectBoxOpen": `EvaluationGroupActionModal-module__selectBoxOpen`,
	"placeholderText": `EvaluationGroupActionModal-module__placeholderText`,
	"selectedText": `EvaluationGroupActionModal-module__selectedText`,
	"arrDownIcon": `EvaluationGroupActionModal-module__arrDownIcon`,
	"arrDownIconOpen": `EvaluationGroupActionModal-module__arrDownIconOpen`,
	"phasesError": `EvaluationGroupActionModal-module__phasesError`,
	"phasesEmpty": `EvaluationGroupActionModal-module__phasesEmpty`,
	"optionsList": `EvaluationGroupActionModal-module__optionsList`,
	"optionButton": `EvaluationGroupActionModal-module__optionButton`,
	"btnContainer": `EvaluationGroupActionModal-module__btnContainer`,
	"cancelBtn": `EvaluationGroupActionModal-module__cancelBtn`,
	"proceedBtn": `EvaluationGroupActionModal-module__proceedBtn`,
	"proceedBtnEnabled": `EvaluationGroupActionModal-module__proceedBtnEnabled`
};
export default ___CSS_LOADER_EXPORT___;
